module.exports = __webpack_public_path__ + "img/expired.2668df1c.png";